export type TSQFunction = (...args: any[]) => any

/** Registers a function that is available to TSQ queries. */
export function TSQFunction(f: TSQFunction): void {
    TSQFunction.functions.push(f)
}
TSQFunction.functions = [] as TSQFunction[]
